import { ViewEntityDialog } from "components/viewDialog/ViewEntityDialog";
import { IViewEntityField } from "components/viewDialog/ViewEntityDialog.types";
import { formatDate } from "utils/generalUtils";
import { IViewUseCaseProps } from "./ViewUseCase.types";

export const ViewUseCase = (props: IViewUseCaseProps): JSX.Element => {
  const { useCase, isOpen, onDismiss } = props;

  const fields: IViewEntityField[] = [
    { label: "Title", value: useCase.title },
    { label: "Author", value: useCase.user?.displayName || "-" },
    { label: "Created At", value: formatDate(useCase.createdAt) },
    { label: "Last Updated", value: formatDate(useCase.updatedAt) },
  ];

  return (
    <ViewEntityDialog
      isOpen={isOpen}
      onDismiss={onDismiss}
      title="View Use Case"
      fields={fields}
      compact
    />
  );
};
